import * as $ from 'jquery';
import { disposableSubscription, Lazy } from 'common/barrels/core';

import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { ViewInfoRequested } from 'runtime/events/viewinforequested';
import { Color } from 'common/color';
import * as rxui from 'common/rxui/core';

import 'runtime/styles/controls/textlabel.less';

export class TextLabel extends Control {
    private $label: JQuery;
    private viewInfo = new Lazy(() => this.eventAggregator.publish(new ViewInfoRequested()));

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element
            .addClass('control-container textlabel')
            .conditionalCss(this.config['content.TransparentToClicks'], 'pointer-events', 'none');

        this.isElementEnabled(this.config.isElementEnabled);
        this.isElementVisible(this.config.isElementVisible);
        this.applyTooltip(this.$element);

        var $container = $('<div />').appendTo(this.$element);

        var languageKey = this.config['content.LanguageKey'];
            
        this.$label = $('<div />')
            .bindText(languageKey ? this.resources.getString(this.viewInfo.value().definitionName, languageKey) : this.config['content.Text'])
            .css('text-align', this.config['content.TextAlignment'].toLowerCase())
            .css('font-size', this.config['content.FontSize'] + 'px')
            .css('font-weight', this.config['content.FontWeight'].toLowerCase())
            .conditionalCss(this.config['content.Cursor'], 'cursor')
            .conditionalCss(this.config['content.Underline'], 'text-decoration', 'underline')
            .conditionalCss(!this.config['content.WrapText'], 'white-space', 'nowrap')
            .conditionalCss(this.config['content.Foreground'], 'color', () => Color.splitArgb(this.config['content.Foreground'])[0])
            .conditionalCss(this.config['content.FontFamily'], 'font-family')
            .conditionalCss(this.config['content.FontStyle'], 'font-style')
            .conditionalClass((this.config['content.TextAlignment'] === 'Right' || this.config['content.TextAlignment'] === 'Justify') && this.config['content.FontStyle'] === 'Italic', 'textlabel-clearanceright')
            .appendTo($container);

        this.subscriptions = disposableSubscription(
            rxui.click(this.$element)
                .let(x => this.config.focusable ? x.merge(rxui.enterPressed(this.$element), rxui.spacePressed(this.$element)) : x)
                .filter(() => this.derivedEnabledState() !== false).subscribe(() => this.triggerEvent('Clicked')),
            this.processBindings(this.config)
        );

        this.initialize();
    }

    'set Text'(text) {
        this.$label.text(text);
    }

    'content.Text'(value) {
        this.$label.text(value === null ? '' : value);
    }

    click() { this.$element.triggerHandler('click'); }

    focus() {
        if (this.config.focusable)
            this.$element.focus();
    }

    tabIndexElements() {
        return this.config.focusable ? this.$element : $();
    }
}    

registerBinding('textlabel', TextLabel);